import { Transport } from './../../../../model/transport.model';
import { Component, Input } from '@angular/core';
import { Station } from '../../../../../client/model/station';
import { StationType } from '../../../../../client/model/station-type.enum';

@Component({
    selector: 'app-station-details',
    templateUrl: './station-details.component.html',
    styleUrls: ['./station-details.component.scss'],
    standalone: false
})
export class StationDetailsComponent {

  station: Station;
  transport: Transport;

  @Input('station') set setStation(value: Station) {
    this.station = value;
    if (this.station?.stationUsage?.transports.length == 1) {
      this.transport = this.station.stationUsage.transports[0];
    }
  }

  @Input() selected = false;

  @Input() enabled: boolean;

  stationType = StationType;

}
